import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getAppParams, getImagesById } from "../../api/api";
import LabelImage from "../cards/image";

const EpgList = (props) => {
  const [characters, updateCharacters] = useState([]);
  const [title, setTitle] = useState([]);
  const [logo, setLogo] = useState([]);
  const [year, setYear] = useState([]);
  const [banner, setBanner] = useState([]);
  const [type] = useState("channel");
  const [options, setOptions] = useState(props.data);

  const onChangeItemed = async (value, event) => {
    setLogo(value.key);
  };

  const handleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleYear = (event) => {
    setYear(event.target.value);
  };

  const checkValueExist = (value, type) => {
    return characters.some(function (el) {
      return el.title === value;
    });
  };

  const handleSave = (evt) => {
    evt.preventDefault();
    const opt = {
      type: type,
      title: title,
      logo: logo,
      year: year,
      order: characters.length + 1,
    };
    if (!checkValueExist(opt.title, "title")) {
      updateCharacters([...characters, opt]);
      const newArr = [...characters, opt];
      props.onChange(newArr);
    } else {
      toastr.error("Year/Title/Logo Already Exist", "Error");
    }
  };

  useEffect(() => {
    /* eslint-disable no-unused-vars */
    setOptions([...props.data]);
    const image = async () => {
      if (logo.id) {
        const results = await getImagesById(logo.id).then(
          (result) => {
            setBanner(result.data);
          },
          (error) => {}
        );
      }
    };
    const getDetails = () => {
      if (props.listData) {
        const opt = props.listData.map((item, index) => ({
          type: item.type,
          title: item.title,
          logo: item.logo,
          year: item.year,
          order: index + 1,
        }));

        updateCharacters(opt);
      }
    };

    getDetails();
    image();
    /* eslint-disable no-unused-vars */
  }, [props.data, props.listData, props.list, logo.id]);
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handleRemove = (event, index) => {
    if (props.num.length !== characters.length) {
      const removeId = index;
      event.preventDefault();
      const items = Array.from(characters);
      items.splice(index, 1);

      reorderArray(items);
    } else {
      toastr.error("Delete the details first", "Error");
    }
  };

  return (
    <div className="row mb-2 mt-2">
      <div className="col-sm-12">
        <div className="form-group">
          <div className="row">
            {props.dir === "rtl" && (
              <div className="col-md-3">
                <Button
                  variant="light"
                  onClick={handleSave}
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                >
                  Save
                </Button>
              </div>
            )}
            <div className="col-sm-3">
              {/* text input */}
              <div className="form-group">
                <label
                  className={props.dir === "rtl" ? "float-right" : "float-left"}
                >
                  Title
                </label>
                <input
                  dir={props.dir}
                  type="text"
                  name="referenceName"
                  className="form-control inside-form"
                  placeholder="Reference Name ..."
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="col-md-3" dir={props.dir}>
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                Logo
              </label>
              <Select
                name="containerList"
                className={
                  props.dir === "rtl"
                    ? "form-control inside-select float-right"
                    : "form-control inside-select float-left"
                }
                options={options}
                onChange={(value, event) => onChangeItemed(value, event)}
              ></Select>
            </div>

            <div className="col-sm-3">
              {/* text input */}
              <div className="form-group">
                <label
                  className={props.dir === "rtl" ? "float-right" : "float-left"}
                >
                  Year
                </label>
                <input
                  dir={props.dir}
                  type="text"
                  name="referenceName"
                  className="form-control inside-form"
                  placeholder="Reference Name ..."
                  onChange={handleYear}
                  autoComplete="off"
                />
              </div>
            </div>
            {!(props.dir === "rtl") && (
              <div className="col-md-3">
                <Button
                  variant="light"
                  onClick={handleSave}
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                >
                  Save
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId={"characters"}>
            {(provided) => (
              <table
                dir={props.dir === "rtl" ? "rtl" : "ltr"}
                id="appadmin"
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="table table-bordered table-hover dataTable dtr-inline"
                role="grid"
                aria-describedby="example2_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting_asc"
                      tabIndex={0}
                      aria-controls="example2"
                      rowSpan={1}
                      colSpan={1}
                    >
                      {" "}
                      <label
                        className={
                          props.dir === "rtl" ? "float-right" : "float-left"
                        }
                      >
                        Order
                      </label>
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="example2"
                      rowSpan={1}
                      colSpan={1}
                    >
                      <label
                        className={
                          props.dir === "rtl" ? "float-right" : "float-left"
                        }
                      >
                        Title
                      </label>
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="example2"
                      rowSpan={1}
                      colSpan={1}
                    >
                      <label
                        className={
                          props.dir === "rtl" ? "float-right" : "float-left"
                        }
                      >
                        Logo
                      </label>
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="example2"
                      rowSpan={1}
                      colSpan={1}
                    >
                      <label
                        className={
                          props.dir === "rtl" ? "float-right" : "float-left"
                        }
                      >
                        Year
                      </label>
                    </th>
                    {/* <th className="sorting" tabIndex={0} aria-controls="example2" rowSpan={1} colSpan={1} ><label className={props.dir==="rtl"?"float-right":"float-left"}>Details</label></th> */}
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="example2"
                      rowSpan={1}
                      colSpan={1}
                    >
                      <label
                        className={
                          props.dir === "rtl" ? "float-right" : "float-left"
                        }
                      >
                        Delete
                      </label>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {characters.map((person, index) => (
                    <Draggable
                      key={person.title + person.order}
                      draggableId={"item" + person.order}
                      index={index}
                    >
                      {(provided) => (
                        <tr
                          role="row"
                          className="even"
                          key={person.order}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <td className="dtr-control sorting_1" tabIndex={0}>
                            <label
                              className={
                                props.dir === "rtl"
                                  ? "float-right"
                                  : "float-left"
                              }
                            >
                              {person.order}
                            </label>
                          </td>
                          <td>
                            <label
                              className={
                                props.dir === "rtl"
                                  ? "float-right"
                                  : "float-left"
                              }
                            >
                              {person.title}
                              {}
                            </label>
                          </td>
                          <td>
                            <LabelImage
                              url={getAppParams() + person.logo}
                              name={person.title}
                            ></LabelImage>
                          </td>
                          <td>
                            <label
                              className={
                                props.dir === "rtl"
                                  ? "float-right"
                                  : "float-left"
                              }
                            >
                              {person.year}
                            </label>
                          </td>
                          <td>
                            <button
                              type="button"
                              className={
                                props.dir === "rtl"
                                  ? "float-right btn btn-light"
                                  : "float-left btn btn-light"
                              }
                              onClick={(event) => handleRemove(event, index)}
                            >
                              <i className="fa fa-trash"></i> Delete
                            </button>
                          </td>
                        </tr>
                      )}
                    </Draggable>
                  ))}

                  {provided.placeholder}
                </tbody>
              </table>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default EpgList;
